import { ComponentProps } from 'react';

import { DEFAULT_IMAGE } from '@/app/_constant/component.constant';
import { cn } from '@/app/_helper/tailwind';

const sizes = {
    md: 'w-[42px] h-[42px]',
    sm: 'w-[24px] h-[24px]',
};
type AvatarProps = {
    src: string;
    size?: keyof typeof sizes;
    alt: string;
    onCallbackError?(): void;
} & ComponentProps<'image'>;
const Avatar = ({
    src,
    size = 'md',
    className,
    alt,
    onCallbackError,
}: AvatarProps) => {
    return (
        <div
            className={cn(
                'rounded-full border border-solid border-greyText relative overflow-hidden shrink-0',
                sizes[size],
            )}
        >
            <img
                alt={alt}
                className={cn(
                    'object-cover w-full h-full object-center',
                    className,
                )}
                src={src || DEFAULT_IMAGE}
                onLoad={({ currentTarget }) => {
                    if (
                        currentTarget.naturalWidth === 374 &&
                        currentTarget.naturalHeight === 280
                    ) {
                        onCallbackError && onCallbackError();
                    }
                }}
                onError={({ currentTarget }) => {
                    const target = currentTarget;
                    target.onerror = null;
                    target.src = DEFAULT_IMAGE;
                }}
                loading='lazy'
            />
        </div>
    );
};

export default Avatar;
